import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../utils/authBaseQuery";
import { add } from "date-fns";
import jwtDecode from "jwt-decode";

export const reduxBaseURL = createApi({
  baseQuery: authBaseQuery,
  tagTypes: [
    "addVendor",
    "addPaycycle",
    "addPlatform",
    "addPayMethod",
    "whatsappLinkType",
    "addBankName",
    "addVendorMaster",
  ],
  endpoints: (builder) => ({
    getnotAssignedVendors: builder.query({
      query: () => `notAssignedToPageVendors`,
      transformResponse: (response) => response.data,
    }),
    AddPmsVendorType: builder.mutation({
      query: (data) => ({
        // url: `addVendor`,
        url: `/v1/vendor_type`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addVendor"],
    }),
    getAllVendorType: builder.query({
      // query: () => `getAllVendor`,
      query: () => `v1/vendor_type`,
      providesTags: ["addVendor"],
    }),

    getAllVendorWiseList: builder.query({
      query: () => "v1/get_page_count_with_unique_vendor_name",
      transformResponse: (response) => response,
      keepUnusedDataFor: 0,
    }),

    updateVendorType: builder.mutation({
      query: (data) => ({
        // url: `updateVendor/${data._id}`,
        url: `/v1/vendor_type`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["addVendor"],
    }),
    addPmsPlatform: builder.mutation({
      query: (data) => ({
        url: `v1/vendor_platform`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addPlatform"],
    }),

    getPmsPlatform: builder.query({
      query: () => `v1/vendor_platform`,
      providesTags: ["addPlatform"],
    }),
    updatePmsPlatform: builder.mutation({
      query: (data) => ({
        // url: `updatePlatform/${data._id}`,
        url: `v1/vendor_platform`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["addPlatform"],
    }),
    addPmsPaymentMethod: builder.mutation({
      query: (data) => ({
        // url: `addpayMethod`,
        url: `v1/payment_method`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addPayMethod"],
    }),

    getPmsPaymentMethod: builder.query({
      query: () => `v1/payment_method`,
      providesTags: ["addPayMethod"],
      transformResponse: (res) => res.data,
    }),

    updatePmsPaymentMethod: builder.mutation({
      query: (data) => ({
        // url: `updatePay/${data._id}`,
        url: `v1/payment_method`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["addPayMethod"],
    }),
    addPmsPayCycle: builder.mutation({
      query: (data) => ({
        // url: `addPayCycle`,
        url: `v1/paycycle`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addPaycycle"],
    }),
    getPmsPayCycle: builder.query({
      query: () => `v1/paycycle`,
      providesTags: ["addPaycycle"],
    }),

    updatePmsPayCycle: builder.mutation({
      query: (data) => ({
        // url: `updatePayCycle/${data._id}`,
        url: `v1/paycycle`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["addPaycycle"],
    }),

    //Vendor Whatsapp group
    addVendorWhatsappLinkType: builder.mutation({
      query: (data) => ({
        url: `v1/group_link_type`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["whatsappLinkType"],
    }),
    getVendorWhatsappLinkType: builder.query({
      query: () => `v1/group_link_type`,
      providesTags: ["whatsappLinkType"],
    }),
    updateVendorWhatsappLinkType: builder.mutation({
      query: (data) => ({
        url: `v1/group_link_type`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["whatsappLinkType"],
    }),
    getSingleBankDetail: builder.query({
      query: (data) => `v1/bank_details_by_vendor_id/${data}`,
      transformResponse: (res) => res.data,
    }),

    //venodr whatsapp group link
    getVendorWhatsappLink: builder.query({
      query: (id) => `v1/vendor_group_link_vendor_id/${id}`,
    }),

    //Country Code
    getCountryCode: builder.query({
      query: () => `v1/country_code`,
      transformResponse: (response) => response.data,
    }),
    addCountryCode: builder.mutation({
      query: (data) => ({
        url: `v1/country_code`,
        method: "POST",
        body: data,
      }),
    }),
    updateCountryCode: builder.mutation({
      query: (data) => ({
        url: `v1/country_code`,
        method: "PUT",
        body: data,
      }),
    }),

    getAllVendor: builder.query({
      query: ({ page, limit, search, vendor_outstandings } = {}) => {
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (limit) queryParams.push(`limit=${limit}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
        if (vendor_outstandings) queryParams.push(`vendor_outstandings=true`);

        const queryString =
          queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

        return `v1/vendor_v2${queryString}`;
      },
      keepUnusedDataFor: 60 * 60,
      providesTags: ["addVendorMaster"],
    }),

    getVendorsWithPagination: builder.query({
      query: ({ page, limit, search } = {}) => {
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (limit) queryParams.push(`limit=${limit}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`);

        const queryString =
          queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

        return `v1/vendor_v2${queryString}`;
      },
      keepUnusedDataFor: 60 * 60,
      providesTags: ["addVendorMaster"],
    }),

    addVendor: builder.mutation({
      query: (data) => ({
        url: `v1/vendor`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addVendorMaster"],
    }),
    updateVenodr: builder.mutation({
      query: (data) => ({
        url: `v1/vendor/${data._id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["addVendorMaster"],
      transformErrorResponse: (error) => {
        return error.data;
      },
    }),

    // Bank Detail Api's:-
    getBankNameDetail: builder.query({
      query: () => `v1/bank_name`,
      providesTags: ["addBankName"],
    }),

    addBankNameDetail: builder.mutation({
      query: (data) => ({
        // url: `addPayCycle`,
        url: `v1/bank_name`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["addBankName"],
    }),
    getVendorById: builder.query({
      query: (vendorId) => `v1/vendor/${vendorId}`,
    }),

    getBankDetailsByVendorId: builder.query({
      query: (vendorId) => `v1/bank_details_by_vendor_id/${vendorId}`,
    }),
    updateBankNameDetail: builder.mutation({
      query: (data) => ({
        // url: `updatePayCycle/${data._id}`,
        url: `v1/bank_name`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["addBankName"],
    }),
    getVendorDocumentByVendorDetail: builder.query({
      query: (data) => {
        return `v1/vendor_wise_document_detail/${data}`;
      },
      transformResponse: (response) => response.data,
    }),

    //vendor document
    addVendorDocument: builder.mutation({
      query: (data) => ({
        url: `v1/document_detail`,
        method: "POST",
        body: data,
      }),
    }),

    deleteVendorDocument: builder.mutation({
      query: (data) => ({
        url: `v1/document_detail/${data?._id}`,
        method: "DELETE",
      }),
    }),

    updateVendorDocument: builder.mutation({
      query: (data) => ({
        url: `v1/document_detail/${data.get(_id)}`, // Include the _id in the endpoint
        method: "PUT", // Use the PUT method for updating
        body: data, // Pass the updated data in the body
      }),
      invalidatesTags: ["addVendor"], // Invalidate relevant tags to refresh data
    }),

    //company name and details
    addCompanyData: builder.mutation({
      query: (data) => ({
        url: `v1/company_name`,
        method: "POST",
        body: data,
      }),
    }),
    //upload csv file to get spreadsheet
    uploadExcel: builder.mutation({
      query: (formData) => ({
        url: `//192.168.2.28:8080/google_sheet_static_with_excel`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [],
    }),
  }),
});

export const {
  useGetnotAssignedVendorsQuery,
  useAddPmsVendorTypeMutation,
  useGetAllVendorTypeQuery,
  useUpdateVendorTypeMutation,
  useAddPmsPlatformMutation,
  useGetPmsPlatformQuery,
  useUpdatePmsPlatformMutation,
  useAddPmsPaymentMethodMutation,
  useGetPmsPaymentMethodQuery,
  useUpdatePmsPaymentMethodMutation,
  useAddPmsPayCycleMutation,
  useGetPmsPayCycleQuery,
  useUpdatePmsPayCycleMutation,
  useAddVendorWhatsappLinkTypeMutation,
  useGetVendorWhatsappLinkTypeQuery,
  useUpdateVendorWhatsappLinkTypeMutation,
  useGetSingleBankDetailQuery,
  useGetVendorWhatsappLinkQuery,
  useGetCountryCodeQuery,
  useAddCountryCodeMutation,
  useUpdateCountryCodeMutation,
  useGetAllVendorQuery,
  useGetVendorsWithPaginationQuery,
  useAddVendorMutation,
  useUpdateVenodrMutation,
  useGetBankNameDetailQuery,
  useAddBankNameDetailMutation,
  useGetVendorByIdQuery,
  useGetBankDetailsByVendorIdQuery,
  useUpdateBankNameDetailMutation,
  useGetVendorDocumentByVendorDetailQuery,
  useAddVendorDocumentMutation,
  useDeleteVendorDocumentMutation,
  useAddCompanyDataMutation,
  useGetAllVendorWiseListQuery,
  useUpdateVendorDocumentMutation,
  useUploadExcelMutation,
} = reduxBaseURL;
